import '../../css/FormTemplate.css'
import { IFormInternalDivTemplate } from "../../interfaces/interface";
import FormEditImg from "./FormEditImg";
import FormErrorDivTemplate from './FormErrorDivTemplate';
import FormTemplateLabel from './FormTemplateLabel';

const FormInternalDivTemplate = (props:IFormInternalDivTemplate) => {

    return (
        <div className={props.errorSpace === true ? "form-template-internal-div error-space" :"form-template-internal-div"}>
                    <FormTemplateLabel id={props.id} label={props.label} dataToolTip={props.dataToolTip}/>
                    {props.checkSign && 
                        <span className='check-icon-span'>
                            <img className='check-icon-img' src="/icons/green-check.png"  alt='green-check'/>
                        </span>
                    }
                    <div className={props.edit === undefined ?'form-template-input-div-without-icon' : 'form-template-input-div-icon'} >
                        <input 
                            list={props.listId ? props.listId : undefined} 
                            name={props.id}
                            id={props.id}
                            className="form-template-input" 
                            value={props.value}
                            onChange={props.onChange}
                            maxLength={props.maxLength}
                            autoComplete={'off'}
                            placeholder={props.placeHolder}
                            onBlur={props.onBlur}
                            disabled={props.disabled}
                        />
                        {
                            (props.edit !== undefined && props.editClickHandler !== undefined ) &&
                                <FormEditImg id={props.id} edit={props.edit} editClickHandler={props.editClickHandler}   />
                        }
                    </div>
                    {
                        props.array &&
                            <datalist id={props.listId}>
                                {
                                    props.array.map((value) => (
                                    <option value={value}/>
                                    ))
                                }
                            </datalist>
                    }
                    {
                        (props.displayMessage !== undefined && props.message !== undefined ) &&
                            <FormErrorDivTemplate displayMessage={props.displayMessage} message={props.message}/>
                    }        
                </div>
    );
};


export default FormInternalDivTemplate;